 

const ConvertNumber = (num) => {
    let numNumber = Number(num)
    let numParse = numNumber.toFixed(2)
    if(numParse === null)
    return
    var i = numParse;
    var re = /(?=\B(?:\d{3})+(?!\d))/g;
    var j = i.toString().replace( re, ' ' ).replace('.', ',');
    return j
    
};

export default ConvertNumber;
